function injectStyle (ssrContext) {
  require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-27a3e3f7\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mivovjqocqq!../../../node_modules/string-replace-webpack-plugin/loader.js?id=q7vc8icot8a!./searchPaginator.vue")
}
var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mivovjqocqq!../../../node_modules/string-replace-webpack-plugin/loader.js?id=q7vc8icot8a!./searchPaginator.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-27a3e3f7\",\"hasScoped\":true}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!../../../node_modules/string-replace-webpack-plugin/loader.js?id=mivovjqocqq!../../../node_modules/string-replace-webpack-plugin/loader.js?id=q7vc8icot8a!./searchPaginator.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-27a3e3f7",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/search/searchPaginator.vue
// module id = 406
// module chunks = 1